import {webRequest, webNoTokenRequest} from '../api'

// 合約版本列表
export function getContractVersionList() {
    return webRequest({
        url:'/v2/oauth/order/manage/contracts/version/list',
        method:'get',
    })
}

// 取得合約版本內容
export function getContractVersionContent(params) {
    return webRequest({
        url:'/v2/oauth/order/manage/contracts/version/edit/page',
        method:'get',
        params: params
    })
}
// 預覽合約版本
export function previewContractVersion(params) {
    return webRequest({
        url:'/v2/oauth/order/manage/contracts/version/preview',
        method:'get',
        params: params
    })
}
// 預覽合約版本
export function previewEditContractVersion(data) {
    return webRequest({
        url:'/v2/oauth/order/manage/contracts/version/preview',
        method:'post',
        data: data
    })
}

// 新增編輯合約版本
export function editContractVersion(data) {
    return webRequest({
        url:'/v2/oauth/order/manage/contracts/edit/version',
        method:'post',
        data: data,
    })
}
// 刪除合約版本
export function deleteContractVersion(data) {
    return webRequest({
        url:'/v2/oauth/order/manage/contracts/delete/version',
        method:'post',
        data: data,
    })
}


// WEBPACK FOOTER //
// ./src/apis/landlord/contractVersion.js